import { BottleSodaOutlineIcon } from './BottleSodaOutlineIcon';

/**
 * author: Michael Richins
 * id 54C4C95B-E05C-4992-8365-96586E864FF9
 * name bottle-soda-outline
 * version: 4.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bottle-soda-outline.svg
 * tags
 * - Food / Drink 
 */
export const BottlePopOutlineIcon = BottleSodaOutlineIcon;
export default BottlePopOutlineIcon